/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Recurso singular — endpoint novo, isolado:
// GET/PATCH /api/v1/accounts/:account_id/branding_setting
class BrandingSettingAPI extends ApiClient {
  constructor() {
    super('branding_setting', { accountScoped: true });
  }

  update({ brandName, logoFile, faviconFile }) {
    const formData = new FormData();
    if (brandName) formData.append('brand_name', brandName);
    if (logoFile) formData.append('logo', logoFile);
    if (faviconFile) formData.append('favicon', faviconFile);

    return axios.patch(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new BrandingSettingAPI();
